class BaseNotificationModule {
  init(config) {
  }
  getData() {
    return null;
  }
  shouldNotify(arg) {
    return true;
  }
  notify(arg) {
  }
  canNotificationBeRemoved(arg) {
    return false;
  }
  removeNotification(arg) {
  }
  shouldFetch() {
    return true;
  }
  fetch(...args) {
    return Promise.resolve(null);
  }
  destruct() {
  }
}
var BaseNotificationModule_default = BaseNotificationModule;
export {
  BaseNotificationModule_default as default
};
